import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useIsDesktop } from '../../hooks';
import { Card, CardContent, CardHeader, FormFlex, FormFlexItem, } from '../../legacy/components';
import { styled } from '../../legacy/utils';
export const InfoCard = ({ title, description, illustration, }) => {
    const isDesktop = useIsDesktop();
    const showIllustration = illustration && isDesktop;
    return (_jsx(Card, { children: _jsxs(FormFlex, { rowGap: 0, columnGap: 0, align: "center", children: [_jsxs(FormFlexItem, { width: showIllustration ? '60%' : '100%', flexGrow: 0, children: [title && _jsx(CardHeader, { title: title }), description && _jsx(CardContent, { children: description })] }), showIllustration && (_jsx(FormFlexItem, { width: "40%", children: _jsx(IllustrationContainerStyled, { children: _jsx(IllustrationStyled, { children: illustration }) }) }))] }) }));
};
const IllustrationContainerStyled = styled('div')(({ theme }) => ({
    width: '100%',
    padding: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-end',
}));
const IllustrationStyled = styled('div')({
    position: 'relative', // necessary for AppImages with fill property (if passed as illustration)
    minHeight: '200px',
    width: '100%',
    maxWidth: '336px',
    bottom: 0,
    display: 'table-cell',
    textAlign: 'right',
});
